module.exports = __webpack_public_path__ + "img/banner@2x.d7624c87.png";